// @flow strict

/* eslint-disable ta-code-conventions/has-matching-storydoc */
import * as React from 'react';
import { escapeHtml } from '@ta/common.text-html';

/** Breadcrumbs for JSON-LD */
export type JsonLdBreadcrumbData = {|
  /** The location name */
  name: string,
  /** The location URL */
  href: string,
|};

type BreadcrumbsJsonLdProps = {|
  breadcrumbList: JsonLdBreadcrumbData[],
|};

const generateJsonLd = crumbList => ({
  '@context': 'http://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: crumbList.map((crumb, index) => ({
    '@type': 'ListItem',
    position: (index + 1).toString(),
    item: {
      '@id': escapeHtml(crumb.href),
      name: escapeHtml(crumb.name),
    },
  })),
});

/* eslint-disable react/no-danger */
const BreadcrumbJsonLd = ({ breadcrumbList }: BreadcrumbsJsonLdProps) =>
  breadcrumbList.length > 0 ? (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(generateJsonLd(breadcrumbList)) }}
    />
  ) : null;
/* eslint-enable react/no-danger */

export default BreadcrumbJsonLd;
